import { render, staticRenderFns } from "./UpcomingBirthdays.vue?vue&type=template&id=1e42bbd3&"
import script from "./UpcomingBirthdays.vue?vue&type=script&lang=js&"
export * from "./UpcomingBirthdays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports